import { useCallback, useMemo, useState } from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Portal from '@material-ui/core/Portal';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: Math.max(theme.zIndex.modal + 10, 20000),
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    cursor: 'wait',
  },
}));

export function useLoadingOverlay() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const show = useCallback(() => setOpen(true), []);
  const hide = useCallback(() => setOpen(false), []);

  const overlay = useMemo(
    () => (
      <Portal>
        <Backdrop
          className={classes.backdrop}
          open={open}
          transitionDuration={0}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Portal>
    ),
    [classes.backdrop, open],
  );

  return { open, show, hide, overlay };
}
